module.exports = __webpack_public_path__ + "media/images/phone-d077ccf8c4bce41c20c85b4480e7f506.png";